import PropTypes from "prop-types"
import classNames from "classnames"
import styles from "./PartialPageLoader.module.scss"

const PartialPageLoader = ({ transparent }) => {
  return (
    <div
      className={classNames(styles.wrapper, "d-flex justify-content-center", {
        [styles.transparent]: transparent
      })}
    >
      <div className="spinner-border text-primary mb-2" role="status" />
    </div>
  )
}

PartialPageLoader.propTypes = {
  transparent: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  copy: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default PartialPageLoader
